<template>
  <div>
    <el-dialog top="0" v-if="messagedialogvisible" class="el-dialog-sm custom-dialog" :visible="messagedialogvisible" 
    width="40%" @close="closeDialog">
      <div class="text-center redirct">
          <p>
            <i class="ico ico-paysucces completion"></i>
          </p>
          <p>{{message}}</p>
      </div>
  </el-dialog>
  </div>
</template>

<script>


export default {
  name: 'MessageDialogs',
  computed: {
    message () {
	    return this.$store.state.messageDialog.message
    },
    messagedialogvisible () {
      return this.$store.state.messageDialog.visible
    },
  },
  data () {
    return {
    }
  },
  methods:{
    closeDialog(){
      this.$store.commit('updateMessageDialog', {visible:false,message:''})
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .redirct {
        font-size:24px;
        line-height:33px;
        padding-bottom: 70px;

        .completion {
            width:76px;
            height:76px;
            background-image: url('../ico/blueSucccess@2x.png');
            background-position: 0 0;
            background-size: contain;
        }
        .fail {
            width:76px;
            height:76px;
            margin: 0 auto;
            border-radius: 50%;

            img {
                height: 33px;
                margin: 21px auto;
            }
        }
        p {
            color: #333333;
            font-size: 18px;
            margin-top: 45px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/MessageDialog.vue